import Query from '../../../../../../components/Report';

const query = ({ project_id, offset = 0, domain }) =>
    new Query('commerce-detail-all-data', { project_id, domain, offset });

export default query;
